module.exports = __webpack_public_path__ + "img/flor_completa.9f884d70.svg";